const cyclicSortProblems = [
  {
      title: "Missing Number",
      url: "https://leetcode.com/problems/missing-number/"
    },
    {
      title: "Find All Numbers Disappeared in an Array",
      url: "https://leetcode.com/problems/find-all-numbers-disappeared-in-an-array/"
    },
    {
      title: "Find the Duplicate Number",
      url: "https://leetcode.com/problems/find-the-duplicate-number/"
    },
    {
      title: "Find All Duplicates in an Array",
      url: "https://leetcode.com/problems/find-all-duplicates-in-an-array/"
    },
    {
      title: "First Missing Positive",
      url: "https://leetcode.com/problems/first-missing-positive/"
    }
];
export default cyclicSortProblems;